import { useTheme } from "@mui/material/styles";
import { tagColorsStyles } from "../../styles/tagColorsStyles";

/**
 * Hook wrapper for tagColorsStyles to maintain backward compatibility
 */
export const useTagColorsStyles = () => {
  const theme = useTheme();
  return tagColorsStyles(theme);
};
